import React, { Component } from "react";
import { withTranslation, Trans } from "react-i18next";
import { connect } from "react-redux";
import ReactPlayer from "react-player";
import { withRouter } from "react-router-dom";
import swal from "sweetalert";
import Grid from "@material-ui/core/Grid";
import parse from 'html-react-parser';
import BookmarkBorderIcon from "@material-ui/icons/BookmarkBorder";
import LinkIcon from "@material-ui/icons/Link";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import ThumbUpAltIcon from "@material-ui/icons/ThumbUpAlt";
import MapIcon from "@material-ui/icons/Map";


import imgUrl from "../../assets/images/imageUrl.js";

import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import Slider from "react-slick";
import Services from "../../api/api";

import DialogBoxTextArea from "../DialogBox/DialogBoxTextArea";
import DialogBoxShareOnSocialMedia from '../DialogBox/DialogBoxShareOnSocialMedia';
import CommentList from '../Comment/CommentList';
import Knowledge from "../Knowledge/Knowledge";
import OffileDb from '../../config/pouchDB';
import { gaLogEvent } from "../../helpers/analytics";

// import KnowYourRights from "./KnowYourRights";

class KnowYourRightsDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isLiked: false,
      totalLikes: null,
      totalComments: null,
      dialogBoxIsOpen: false,
      socialDialogBoxIsOpen: false,
      commentList: [],
      currentVideoSlide: 0,
      videoFlag: []
    };
    this.nextClick = this.nextClick.bind(this);
    this.afterChange = this.afterChange.bind(this);
    this.onPlay = this.onPlay.bind(this);
    this.onPause = this.onPause.bind(this);
  }

  componentDidMount() {

    OffileDb.setDatabase()
    console.log("knowledge123>>>", this.props);
    if (!this.props.location.state) {
      this.props.history.push('/layout');
    }

    const { state } = { ...this.props.location };
    // const { state } = { ...location };

    if (!state) {
      return;
    }

    this.setState({
      totalLikes: state.totalLikes,
      isLiked: state.isLiked,
      totalComments: state.totalComments,
    });
    this.createVideoObj(state);
    this.getContentWiseComments(state);
    try{
      gaLogEvent("Know your rights123 "+this.props.location.state.contentName, '', '');
    }catch(err){
      console.log("err::", err);
    }

  }

  getContentWiseComments(contentobj) {
    this.loadOfflineData(contentobj)
    if (navigator.onLine) {
      let params = {
        communityId: this.props.communityuid,
        contentId: contentobj.contentId,
      }
      var dbid = 'KnowYourRightComment-' + contentobj.contentId
      console.log("getContentWiseComments params>>", params);
      Services.getContentWiseComments(params).then((res) => {
        try{
          console.log("getContentWiseComments res>>", res);
          if (res.data.status == 200) {
            this.setState({
              commentList: res.data.data
            });
            OffileDb.setData(dbid, res.data.data)
          }
        }catch(err){
          console.log("err::", err)
        }
      });
    }
  }

  loadOfflineData(contentobj) {
    var that = this
    var dbid = 'KnowYourRightComment-' + contentobj.contentId
    OffileDb.getData(dbid).then(function (result) {
      console.log(result)
      if (!result.status && result.status != 404) {
        that.setState({
          commentList: result.data,
        });
      }
    });
  }

  addComment() {
    this.setState({
      dialogBoxIsOpen: true,
    });
  }

  onLikeUnlike(contentobj) {
    if (this.state.isLiked) {
      this.unlikeContent(contentobj);
    } else {
      this.likeContent(contentobj);
    }
  }

  likeContent(contentobj) {
    console.log("onLike>>", contentobj);
    let params = {
      communityId: this.props.communityuid,
      contentId: contentobj.contentId,
      contentName: contentobj.contentName,
      profileLink: "",
      userId: JSON.parse(localStorage.getItem("obj")).userId,
      userName: "",
    };
    console.log("onLike params>>", params);
    Services.likeContent(params).then((res) => {
      try{
        console.log("onlike res>>", res);
        if (res.data.status == 200) {
          this.setState({
            totalLikes: res.data.data.totalLikes,
            isLiked: true,
          });
        }
      }catch(err){
        console.log("err::", err)
      }
    });
  }

  unlikeContent(contentobj) {
    console.log("unlikeContent>>", contentobj);
    let params = {
      communityId: this.props.communityuid,
      contentId: contentobj.contentId,
      contentName: contentobj.contentName,
      profileLink: "",
      userId: JSON.parse(localStorage.getItem("obj")).userId,
      userName: "",
    };
    console.log("unlikeContent params>>", params);
    Services.unlikeContent(params).then((res) => {
      try{
        console.log("unlikeContent res>>", res);
        if (res.data.status == 200) {
          this.setState({
            totalLikes: res.data.data.totalLikes,
            isLiked: false,
          });
        }
      }catch(err){
        console.log("err::", err)
      }
    });
  }

  addCommentToContent(contentobj, comment) {
    console.log("addCommentToContent>>", contentobj);
    let params = {
      comment: comment,
      communityId: this.props.communityuid,
      contentId: contentobj.contentId,
      contentName: contentobj.contentName,
      profileLink: "",
      userId: JSON.parse(localStorage.getItem("obj")).userId,
      userName: "",
    };
    console.log("addCommentToContent params>>", params);
    Services.addCommentToContent(params).then((res) => {
      console.log("addCommentToContent res>>", res);
      if (res.data.status == 200) {
        this.setState({
          dialogBoxIsOpen: false,
          totalComments: res.data.data.totalComments
        }, () => {
          this.getContentWiseComments(contentobj)
        });
      }
    });
  }


  toggleDialogBox(status) {
    this.setState({
      dialogBoxIsOpen: status
    })
  }

  toggleSocialDialogBox(status) {
    this.setState({
      socialDialogBoxIsOpen: status
    })
  }


  createVideoObj(state) {
    if (state.contentList &&
      state.contentList.length > 0 &&
      state.contentList[0].infographics &&
      state.contentList[0].infographics.video &&
      state.contentList[0].infographics.video.length > 0) {
      var len = state.contentList[0].infographics.video.length
      this.setState({ videoFlag: Array(len).fill(false) })
    }
  }

  nextClick(e) {
    var arr = this.state.videoFlag
    arr[e] = false;
    this.setState({
      videoFlag: arr
    })
  }

  afterChange(current) {
    // console.log(current)
    //console.log(this.state.videoFlag)
    // this.setState({
    //   currentVideoSlide: current,
    //   isPlay:false
    // })
  }

  onPlay(key) {
    var arr = this.state.videoFlag
    arr[key] = true;
    this.setState({
      videoFlag: arr
    })
  }


  onPause(key) {
    var arr = this.state.videoFlag
    arr[key] = false;
    this.setState({
      videoFlag: arr
    })
  }

   getHttpsUrl(iconurl) {
    var spliurtl = iconurl.split("://")
    let myUrl = spliurtl.length > 1 ? "https://" + spliurtl[1] : "https://" + spliurtl[0];
    return myUrl;
  }


  render() {
    const { state } = { ...this.props.location };
    const { t } = this.props;
    const { templateID } = this.props;
    let colorStyles = templateID == 2 ? { background: this.props.componentbgcolor } : {};
    let bgStyles = templateID == 2 ? { backgroundImage: `linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), url(${state.contentList[0].backgroundImage})` } : {};
    // const { state } = { ...location };

    if (!state) {
      this.props.history.push("/layout/knowyourrights");
      return null;
    }

    console.log("kyrstate>>", state);

    if (state && !state.contentList) {
      return null
    }

    if (state && (state.contentList && state.contentList.length == 0)) {
      return null;
    }
    var settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      swipeToSlide: true,
      adaptiveHeight: true,
      slidesToScroll: 1,
      fade: false,
      beforeChange: this.nextClick,
      afterChange: this.afterChange,
    };


    return (
      <div id="know-your-right-detail" className="gk-page getknowledge-page getknowledgeable_page">
        {
          templateID == 1 && (
            <div className="backgroundivholder">
              <div className="bgdiv1">
                <div class="welcometopcurve">
                  <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z" class="shape-fill"></path>
                  </svg>
                </div>
              </div>
              <div className="bgdiv2"></div>
            </div>
          )
        }
        <div className="gridcontainer">
          <Grid container spacing={3} className="gridcontainer">
            <Grid item xs={12} className="gkdivcontent zero knowledge-detail">
              <div className="infolinkcontainer content-detail-action d-flex">
                <Link onClick={() => this.addComment(state)}>
                  <ChatBubbleOutlineIcon />
                  <span className="likecountholder">
                    {this.state.totalComments}
                  </span>
                </Link>
                <Link
                  className={this.state.isLiked ? "active" : ""}
                  onClick={() => this.onLikeUnlike(state)}
                >
                  <ThumbUpAltIcon />
                  <span className="likecountholder">
                    {this.state.totalLikes}
                  </span>
                </Link>
              </div>
              <div className="scrollablepost" style={bgStyles}>
                <div className="infodetailedpostcontainer">
                  {
                    state.contentList[0].logoURL ? (
                      <div className="avatarholder mt-10px">
                        <p className="zero text-center">
                          <img
                            className="oneimpactlogoimg"
                            src={this.getHttpsUrl(state.contentList[0].logoURL)}
                          />
                        </p>
                      </div>) : ('')
                  }
                  <div className="postcontainer">
                    <p className="posttitle" style={{ color: this.props.componentbgcolor }}>
                      {state.contentList[0].title}
                    </p>
                    <p className="postinfo">
                      {/* {state.contentList[0].shortDesc} */}
                    </p>
                    <p className="postinfo">
                      {parse(state.contentList[0].description)}
                    </p>
                    <p className="infoupdatedate">
                      {state.contentList[0].lastModifiedAt ||
                        state.contentList[0].date}
                    </p>
                  </div>
                </div>
                <div>
                  <p className={state.contentList[0].infographics && state.contentList[0].infographics.video.length > 0 ? "text-center championvideobig" : "text-center"}>
                    <Slider {...settings} className="slider">
                      {state.contentList &&
                        state.contentList.length > 0 &&
                        state.contentList[0].infographics &&
                        state.contentList[0].infographics.video &&
                        state.contentList[0].infographics.video.length > 0 &&
                        state.contentList[0].infographics.video.map(
                          (url, key) => {
                            var controflg = state.contentList[0].infographics.video[key].includes('vimeo')

                            return (
                              <ReactPlayer
                                url={state.contentList[0].infographics.video[key]}
                                width={"100%"}
                                height={200}

                                style={{ marginTop: "0px" }}
                                playing={this.state.videoFlag[key]}
                                onPlay={() => this.onPlay(key)}
                                onPause={() => this.onPause(key)}
                                //onPlay={this.onPlay}
                                //onPause={this.onPause}
                                controls={controflg}
                              />
                              // <KnowledgeDetailVideo currentVideoSlide={this.state.currentVideoSlide == key} number={key} url={state.contentList[0].infographics.video[key]} playVid={this.state.isPlay}></KnowledgeDetailVideo>
                            )
                          }
                        )}
                    </Slider>
                    {state.contentList &&
                      state.contentList.length > 0 &&
                      state.contentList[0].infographics &&
                      state.contentList[0].infographics.image &&
                      state.contentList[0].infographics.image.length > 0 &&
                      state.contentList[0].infographics.image.map(
                        (url, key) => {
                          return (<img
                            src={state.contentList[0].infographics.image[key]}
                            width={"100%"}
                            height={200}
                            light={true}
                            style={{ marginTop: "0px" }}
                          />)
                        }
                      )}
                  </p>
                </div>
                <div className={state.hasChild ? "knowledge-accordian-row" : ""}>
                  {state.hasChild && (
                    <Knowledge parentKnowledgeObj={state} />
                  )}
                </div>
                {this.state.commentList.length > 0 &&
                  <div className="posticoncontainer">
                    <p className="postinfo"> <Trans> {t("Comments")} </Trans></p>
                    <CommentList commentList={this.state.commentList} />
                  </div>
                }
              </div>
            </Grid>
          </Grid>
          <DialogBoxTextArea
            open={this.state.dialogBoxIsOpen}
            closeDialog={() => this.toggleDialogBox(false)}
            onSubmit={(content) => this.addCommentToContent(state, content)}
          />
          <DialogBoxShareOnSocialMedia
            open={this.state.socialDialogBoxIsOpen}
            contentObj={state}
            closeDialog={() => this.toggleSocialDialogBox(false)}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    componentbgcolor: storeState.componentbgcolor
  };
};

const transKnowYourRightsDetail = withTranslation()(KnowYourRightsDetail);
const routeKnowYourRightsDetail = withRouter(transKnowYourRightsDetail);
export default connect(mapStateToProps, {})(routeKnowYourRightsDetail);
